import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { StafAvailabilityConfigResponse } from '../models/staff-availability-config';
import { StaffAppointmentTytpeLinkResponse } from '../models/StaffAppointmentTytpeLink';

@Injectable({
  providedIn: 'root'
})
export class StaffAppointmentTypeLinkService {

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private router: Router) { }


  GetStaffAppointmentLink(tenantId: number, staffId: number):Observable<StafAvailabilityConfigResponse>
  {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/staff/${staffId}/assigned_appointment_types`;
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetStaffAppointmentLinkByCategoryId(tenantId: number, appointmentCategoryId: number):Observable<StaffAppointmentTytpeLinkResponse>
  {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/appointments/${appointmentCategoryId}/assigned_staffs`;
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
